import { useSession, signOut as betterAuthSignOut } from '../lib/auth-client';

export function useAuth() {
  const { data: session, isPending, error } = useSession();

  // Treat session errors as "not loading" — don't let the UI stay stuck
  // on a loading screen when the session check has failed.
  const isLoading = isPending && !error;

  return {
    user: session?.user ?? null,
    session: session?.session ?? null,
    isLoading,
    isAuthenticated: !!session?.user,
    error: error ?? null,
    logout: async () => {
      try {
        await betterAuthSignOut();
      } catch (err) {
        console.error('Logout error:', err);
      }
    },
  };
}
